//Auth
export const LOGIN_FB = "LOGIN_FB"
export const LOGIN_GM = "LOGIN_GM"
export const LOGIN_LN = "LOGIN_LN"
export const LOGIN_LOCAL = "LOGIN_LOCAL"
export const LOGOUT_FB = "LOGOUT_FB"
export const LOGOUT_LOCAL = "LOGOUT_LOCAL"
export const RESTORE_SESSION = "RESTORE_SESSION"
export const SIGNUP_USER = "SIGNUP_USER"
export const NEWPASSWORD_REQ = "NEWPASSWORD_REQ"
export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const RESET_PASSWORD = "RESET_PASSWORD"
export const RESEND_VARIFICATION = "RESEND_VARIFICATION"
export const UPDATE_USER_ATTRIBS = "UPDATE_USER_ATTRIBS"
export const ADD_USER_OBJECTS = "ADD_USER_OBJECTS"
export const CHANGE_PASSWORD = "CHANGE_PASSWORD"
export const GET_USER = "GET_USER"
export const CREATE_USER = "CREATE_USER"
export const UPDATE_USER = "UPDATE_USER"
export const FAVORITE_PROJECT = "FAVORITE_PROJECT"
export const FOLLOW_USER = "FOLLOW_USER"
export const WRITE_RATING = "WRITE_RATING"
export const GET_RATING = "GET_RATING"
export const UPDATE_RATING = "UPDATE_RATING"
export const SEND_EMAIL = "SEND_EMAIL"
export const UPDATE_LATEST_LOGIN = "UPDATE_LATEST_LOGIN"

//Project
export const GET_LIST_GLOBAL_PROJECT = "GET_LIST_GLOBAL_PROJECT"
export const GET_LIST_MY_PROJECT = "GET_LIST_MY_PROJECT"
export const GET_OTHER_PROJECT = "GET_OTHER_PROJECT"
export const GET_PROJECT = "GET_PROJECT"
export const GET_PROJECT_HISTORY = "GET_PROJECT_HISTORY"
export const UPDATE_PROJECT = "UPDATE_PROJECT"
export const DELETE_PROJECT = "DELETE_PROJECT"
export const CREATE_PROJECT = "CREATE_PROJECT"
export const CLEAR_PROJECT = "CLEAR_PROJECT"
export const CLEAR_LIST_GLOBAL_PROJECT = "CLEAR_LIST_GLOBAL_PROJECT"
export const CLEAR_LIST_MY_PROJECT = "CLEAR_LIST_MY_PROJECT"
export const CLEAR_OTHER_PROJECT = "CLEAR_OTHER_PROJECT"
export const CLEAR_REPORTFILE = "CLEAR_REPORTFILE"
export const QUERY_GLOBAL_PROJECT = "QUERY_GLOBAL_PROJECT"
export const QUERY_MY_PROJECT = "QUERY_MY_PROJECT"
export const PUT_REPORTFILE = "PUT_REPORTFILE"
export const GET_REPORTFILE = "GET_REPORTFILE"
export const DELETE_REPORTFILE = "DELETE_REPORTFILE"
export const ADD_AMOUNT_COMMENT = "ADD_AMOUNT_COMMENT"
export const REDUCE_AMOUNT_COMMENT = "REDUCE_AMOUNT_COMMENT"
export const ADD_TO_MY_PROJECT = "ADD_TO_MY_PROJECT"
export const GET_RECOMMEND_PROJECT = "GET_RECOMMEND_PROJECT"

//Community
export const GET_POSTS = "GET_POSTS"
export const CLEAR_POSTS = "CLEAR_POSTS"
export const GET_COMMENT = "GET_COMMENT"
export const CLEAR_COMMENT = "CLEAR_COMMENT"
export const CREATE_COMMENT = "CREATE_COMMENT"
export const UPDATE_COMMENT = "UPDATE_COMMENT"
export const DELETE_COMMENT = "DELETE_COMMENT"
export const LIKE_PROJECT = "LIKE_PROJECT"
export const UNLIKE_PROJECT = "UNLIKE_PROJECT"
export const GET_PROJECT_NOTI = "GET_PROJECT_NOTI"

//Assignment
export const CREATE_ASSIGNMENT = "CREATE_ASSIGNMENT"
export const GET_ASSIGNMENT = "GET_ASSIGNMENT"
export const GET_EACH_ASSIGNMENT = "GET_EACH_ASSIGNMENT"
export const CLEAR_ASSIGNMENT = "CLEAR_ASSIGNMENT"
export const DELETE_ASSIGNMENT = "DELETE_ASSIGNMENT"
export const UPDATE_ASSIGNMENT = "UPDATE_ASSIGNMENT"
export const GENERATE_SCRIPT = "GENERATE_SCRIPT"
export const GET_SCRIPT = "GET_SCRIPT"
export const CLEAR_SCRIPT = "CLEAR_SCRIPT"
export const CREATE_SCRIPT_ASSIGNMENT = "CREATE_SCRIPT_ASSIGNMENT"
export const UPDATE_SCRIPT_ASSIGNMENT = "UPDATE_SCRIPT_ASSIGNMENT"
export const DELETE_SCRIPT_ASSIGNMENT = "DELETE_SCRIPT_ASSIGNMENT"

//File
export const GET_FILES = "GET_FILES"
export const PUT_FILES = "PUT_FILES"
export const DELETE_FILES = "DELETE_FILES"
export const UPDATE_FILES = "UPDATE_FILES"
export const CLEAR_FILES = "CLEAR_FILES"
export const UPLOAD_PROFILE_IMAGE = "UPLOAD_PROFILE_IMAGE"

//AdvancedSearch
export const ADVANCED_SEARCH = "ADVANCED_SEARCH"
export const KEYWORD_SEARCH = "KEYWORD_SEARCH"

//Notification
export const GET_NOTIFICATION = "GET_NOTIFICATION"
export const CLEAR_NOTIFICATION = "CLEAR_NOTIFICATION"
export const SEEN_NOTIFICATION = "SEEN_NOTIFICATION"
export const SUBSCRIPTION_NOTIFICATION = "SUBSCRIPTION_NOTIFICATION"
export const GET_CHECK_NOTI = "GET_CHECK_NOTI"

//Tutorial
export const TOUR = {
	OPEN_TOUR: "OPEN_TOUR",
	CLOSE_TOUR: "CLOSE_TOUR",
	TYPE_TOUR: "TYPE_TOUR"
}

//History
export const GET_HISTORY = "GET_HISTORY"
export const SUBSCRIBE_NEW = "SUBSCRIBE_NEW"

//Blogs
export const GET_BLOGS = "GET_BLOGS"
